import { Component, OnInit } from '@angular/core';

import { TokensFieldComponent } from './tokens-field.component';

@Component({
  selector: 'app-emails-field',
  templateUrl: './tokens-field.component.html',
  styleUrls: ['./emails-field.component.scss']
})
export class EmailsFieldComponent extends TokensFieldComponent {

  pattern: string = "^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$";

  onSpaceKey() {
    this.commitValue();
    return false;
  }

  onValueChange(value) {
    if (/,/.test(value)) {
      this.commitValue();
    }
  }

  commitValue() {
    if (this.control.value != null) {
      let values = this.control.value.split(/[,;\s]/);
      for (let value of values) {
        if (value != null && value.trim() !== '') {
          let item = this.itemFromControlValue(value);
          this.validateItem(item);
          this.addItem(item);
        }
      }
      this.control.setValue('');
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/forms/emails-field.component.ts